// src/components/Success.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './Success.css';

const Success = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [sessionDetails, setSessionDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  
  const sessionId = searchParams.get('session_id');
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

  useEffect(() => {
    if (sessionId) {
      fetchSessionDetails();
    } else {
      setLoading(false);
    }
  }, [sessionId]);

  const fetchSessionDetails = async () => {
    try {
      const response = await fetch(`${API_URL}/api/payments/session/${sessionId}`);
      if (response.ok) {
        const data = await response.json();
        setSessionDetails(data);
      }
    } catch (error) {
      console.error('Error fetching session details:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="success-container">
      <div className="success-card">
        <div className="success-icon">
          <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
            <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
            <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
          </svg>
        </div>
        
        <h1>Payment Successful!</h1>
        <p className="success-message">
          Thank you for your payment. Your project has been created and our team will contact you within 24 hours.
        </p>
        
        {sessionDetails && (
          <div className="payment-details">
            <div className="detail-row">
              <span>Amount Paid:</span>
              <strong>${sessionDetails.amount}</strong>
            </div>
            <div className="detail-row">
              <span>Email:</span>
              <strong>{sessionDetails.customerEmail}</strong>
            </div>
          </div>
        )}
        
        <div className="success-actions">
          <button 
            onClick={() => navigate('/dashboard')}
            className="btn-dashboard"
          >
            Go to Dashboard
          </button>
          <button 
            onClick={() => navigate('/')}
            className="btn-home"
          >
            Back to Home
          </button>
        </div>
        
        <div className="success-footer">
          <p>A confirmation email has been sent to your email address.</p>
          <p>If you have any questions, please contact us at:</p>
          <a href="tel:+19178087320">(917) 808-7320</a>
        </div>
      </div>
    </div>
  );
};

export default Success;